export default {
  default: 'true',
  locale: 'en',
  cmsLocale: 'en',
  description: 'English'
};
